<template>
  <div>
    <v-btn
      :color="active ? 'green' : 'blue-grey'"
      class="white--text"
      block
      @click="download ? '' : $refs.fileSelect.click()"
    >
      <a v-if="download" class="filename white--text" :href="download">{{
        filename
      }}</a>
      <span v-else class="filename">{{ filename }}</span>
      <v-spacer></v-spacer>
      <v-icon v-if="!active" right dark>cloud_upload</v-icon>
      <v-icon v-else right dark @click.stop="remove">close</v-icon>
    </v-btn>
    <input
      type="file"
      :accept="accept"
      style="display: none"
      ref="fileSelect"
      @change="fileSelected"
    />
  </div>
</template>

<script>
export default {
  name: "upload-button",
  props: {
    accept: String,
    prefill: [String, File],
    download: String
  },
  data() {
    return {
      active: false,
      filename: "Belum ada file dipilih..."
    };
  },
  methods: {
    fileSelected(e) {
      let file = e.target.files[0];
      if (file) {
        if (file.type !== this.accept) {
          this.$emit("error", { message: "Format file tidak didukung!" });
          return;
        }
        this.$emit("change", file);
        this.active = true;
        this.filename = file.name;
      } else {
        this.$emit("change", null);
        this.active = false;
        this.filename = "Belum ada file dipilih...";
      }
    },
    remove() {
      this.$refs.fileSelect.value = "";
      this.active = false;
      this.filename = "Belum ada file dipilih...";
      this.$emit("remove");
    }
  },
  watch: {
    prefill() {
      if (this.prefill) {
        this.active = true;
        if (typeof this.prefill === "string") this.filename = this.prefill;
        else this.filename = this.prefill.name;
      } else {
        this.active = false;
        this.filename = "Belum ada file dipilih...";
      }
    }
  },
  mounted() {
    if (this.prefill) {
      this.active = true;
      if (typeof this.prefill === "string") this.filename = this.prefill;
      else this.filename = this.prefill.name;
    }
  }
};
</script>

<style scoped>
.filename {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: no-wrap;
  width: 80%;
  text-align: left;
}
</style>
